export const KNOWN_PARTNER_ICON_URLS = {
  BOOKING_COM:
    'https://cdn.brandfetch.io/id9mEmLNcV/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1725855381233',
  AIRBNB:
    'https://cdn.brandfetch.io/idkuvXnjOH/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1717146459610',
  EXPEDIA:
    'https://cdn.brandfetch.io/idAGaivHFH/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1740983477322',
  HOTELS_COM:
    'https://cdn.brandfetch.io/id-Jaka7NL/w/1036/h/1036/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1752726775702',
  HOSTELWORLD:
    'https://cdn.brandfetch.io/idnWCUvGGn/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1758985739168',
  VRBO: 'icons/ota/vrbo.png',
  TRIPADVISOR:
    'https://cdn.brandfetch.io/idRUNqV3ke/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1756096188646',
  AGODA:
    'https://cdn.brandfetch.io/idTHPM_cVI/w/400/h/400/theme/dark/icon.jpeg',
};

export const VRBO_ICON_BACKGROUND = '#0E214B';

export const PARTNER_ICON_CONTAIN_FIT_CODES = new Set(['VRBO']);

export function resolveAssetUrl(url) {
  if (!url) {
    return null;
  }
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  let path = url;
  if (path.startsWith('/static/')) {
    path = path.slice('/static/'.length);
  }
  path = path.replace(/^\//, '');

  const staticBase =
    (typeof window !== 'undefined' && window.HIGHTIDE_STATIC_URL) || '/static/';
  const normalizedBase = staticBase.endsWith('/')
    ? staticBase
    : `${staticBase}/`;

  if (/^https?:\/\//i.test(normalizedBase)) {
    return `${normalizedBase}${path}`;
  }

  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  return `${origin}${normalizedBase}${path}`;
}

export function getPartnerIconUrl(partner) {
  if (!partner) {
    return null;
  }
  // Prefer curated known OTA icons (correct CDN params / local static assets).
  // DB logo_url values are often stale Brandfetch defaults that 404 in the browser.
  const knownUrl = getPartnerIconUrlByCode(partner.booking_source_code);
  if (knownUrl) {
    return knownUrl;
  }
  if (partner.logo_url) {
    return resolveAssetUrl(partner.logo_url);
  }
  return null;
}

export function getPartnerIconUrlByCode(bookingSourceCode) {
  if (!bookingSourceCode) {
    return null;
  }
  const url = KNOWN_PARTNER_ICON_URLS[bookingSourceCode];
  return url ? resolveAssetUrl(url) : null;
}

export function partnerIconNeedsContainFit(partner) {
  return PARTNER_ICON_CONTAIN_FIT_CODES.has(partner?.booking_source_code);
}

export function getPartnerIconBackground(partner) {
  if (partner?.booking_source_code === 'VRBO') {
    return VRBO_ICON_BACKGROUND;
  }
  return null;
}

export function getPartnerInitial(partner) {
  const name = partner?.name?.trim();
  if (!name) {
    return '?';
  }
  return name.charAt(0).toUpperCase();
}

export const HIGHTIDE_PARTNER_INITIAL_BADGE_BG = '#198754';
export const HIGHTIDE_PARTNER_INITIAL_BADGE_COLOR = '#ffffff';

export function getPartnerBadgeStyle(partner) {
  if (getPartnerIconUrl(partner)) {
    return 'background-color: transparent; border: none; box-shadow: none;';
  }
  return [
    `background-color: ${HIGHTIDE_PARTNER_INITIAL_BADGE_BG}`,
    `color: ${HIGHTIDE_PARTNER_INITIAL_BADGE_COLOR}`,
    'border: none',
    'box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12)',
  ].join('; ');
}
